import { use } from 'react';
import {
  ToastContext,
  ToastContextType,
} from '@/contexts/toast-context-definition';

export const useToast = (): ToastContextType => {
  const context = use(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};
